/* integrity.js — Panneau intégrité : calcul de l'empreinte SHA-256 (via
 * hash.worker.js, progression exacte) et vérification contre une empreinte
 * fournie. Expose window.Integrity : { setFile(file), reset(), digest() }. */
(function () {
  'use strict';

  var worker = null;
  var file = null;
  var digest = null;
  var pendingVerify = false;
  var els = {};

  function $(id) { return document.getElementById(id); }

  function ensureWorker() {
    if (worker) return worker;
    worker = new Worker(new URL('./workers/hash.worker.js', import.meta.url), { type: 'module' });
    worker.onmessage = function (e) {
      var m = e.data || {};
      if (m.type === 'progress') {
        els.prog.hidden = false;
        els.prog.value = Math.round(100 * m.done / m.total);
      } else if (m.type === 'done') {
        els.prog.value = 100; els.prog.hidden = true;
        digest = m.digest;
        els.digest.textContent = digest;
        els.btnHash.disabled = false; els.btnVerify.disabled = false;
        if (pendingVerify) { pendingVerify = false; doVerify(); }
        else setStatus('Empreinte calculée.', 'ok');
      } else if (m.type === 'error') {
        els.prog.hidden = true; els.btnHash.disabled = false; els.btnVerify.disabled = false;
        setStatus('Le calcul de l’empreinte a échoué : ' + (m.error || ''), 'err');
      }
    };
    return worker;
  }

  function setStatus(msg, kind) {
    els.status.textContent = msg;
    els.status.className = 'int-status' + (kind === 'ok' ? ' ok' : kind === 'err' ? ' err' : '');
  }

  function normalizeHex(s) {
    return String(s || '').toLowerCase().replace(/[^0-9a-f]/g, '');
  }

  function compute(thenVerify) {
    if (!file) return;
    digest = null; els.digest.textContent = '';
    pendingVerify = !!thenVerify;
    els.btnHash.disabled = true; els.btnVerify.disabled = true;
    els.prog.hidden = false; els.prog.value = 0;
    setStatus('Calcul de l’empreinte…', '');
    ensureWorker().postMessage({ type: 'hash', file: file });
  }

  function doVerify() {
    var ref = normalizeHex(els.ref.value);
    if (ref.length !== 64) { setStatus('Empreinte de référence invalide (64 caractères hexadécimaux attendus).', 'err'); return; }
    if (!digest) { compute(true); return; }
    if (ref === digest) setStatus('Intégrité vérifiée par rapport à l’empreinte fournie.', 'ok');
    else setStatus('Échec de vérification — l’empreinte ne correspond pas.', 'err');
  }

  function reset() {
    file = null; digest = null; pendingVerify = false;
    if (els.digest) { els.digest.textContent = ''; els.ref.value = ''; els.prog.hidden = true; setStatus('', ''); els.btnHash.disabled = false; els.btnVerify.disabled = false; }
  }

  function setFile(f) {
    file = f; digest = null; pendingVerify = false;
    if (els.digest) { els.digest.textContent = ''; els.prog.hidden = true; setStatus('', ''); els.btnHash.disabled = false; els.btnVerify.disabled = false; }
  }

  function init() {
    els.panel = $('integrity'); els.btnHash = $('btnHash'); els.prog = $('hashProg');
    els.digest = $('hashDigest'); els.ref = $('hashRef'); els.btnVerify = $('btnVerify'); els.status = $('hashStatus');
    if (!els.btnHash) return;
    els.btnHash.addEventListener('click', function () { compute(false); });
    els.btnVerify.addEventListener('click', function () { doVerify(); });
  }

  window.Integrity = { setFile: setFile, reset: reset, digest: function () { return digest; } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
